<template>
  <div class="" style="padding: 0; height: 250px; width: 100%">
    <div
      class=""
      id="intleftCenter"
      @mouseenter="clearDispatchTimer"
      @mouseleave="setDispatchTimer"
      style="height: 100%; width: 100%"
    ></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-gl";
export default {
  props: {
    waterData: {
      type: String,
    },
  },
  data() {
    return {
      interVal: "",
      myChart: null,
      app: {
        currentIndex: -1,
      },
      dispatchTimer: null,
      dataLen: null,
    };
  },
  mounted() {
    // this.requestData()
    this.init();
  },
  methods: {
    requestData() {
      this.$request(`iot/screen/water/getRate?id=${this.waterId}`).then(
        (res) => {
          if (this.myChart) {
            clearInterval(this.dispatchTimer);
            this.myChart.clear();
          }
          this.init(res.data);
        }
      );
    },
    init(pageData, type) {
      if (this.myChart) {
        clearInterval(this.dispatchTimer);
        this.myChart.clear();
      }
      let that = this;
      that.myChart = echarts.init(document.getElementById("intleftCenter"));

      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        that.myChart.resize();
      });

      var baseDate = `${new Date().getFullYear()}/${
        new Date().getMonth() + 1
      }/${new Date().getDate()}`;
      // echart配置
      var option = {
        tooltip: {
          show: true,
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "rgba(255,255,255,0.8)",
          textStyle: {
            color: "#333",
          },
        },
        grid: {
          top: "4%",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        legend: {
          data: ["工作时长", "工作效率"],
          right: "35%",
          top: "2%",
          textStyle: {
            color: "#fff",
            lineHeight: 12,
            fontSize: 12,
          },
          itemWidth: 12,
          itemHeight: 6,
        },
        // 添加第二个 xAxis 用于折线图偏移, "无人机"
        xAxis: [
          {
            type: "category",
            data: ["拖拉机", "收割机", "播种机", "喷药机", "去雄机"],
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "#fff",
              fontSize: 12,
              margin: 20,
            },
            axisLine: {
              lineStyle: {
                color: "#3C6579",
                width: 1,
              },
            },
          },
          {
            type: "category",
            data: ["拖拉机", "收割机", "播种机", "喷药机", "去雄机"],
            // 隐藏第二个 xAxis 的所有视觉元素, "无人机"
            show: false,
            // 调整偏移量（负值表示向左偏移，正值向右）
            offset: -15,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "工作时长",
            nameTextStyle: {
              color: "#fff",
              fontSize: 12,
            },
            axisLine: {
              lineStyle: {
                color: "#3C6579",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: "#173055",
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#fff",
              fontSize: 12,
            },
          },
          {
            type: "value",
            name: "工作效率",
            nameTextStyle: {
              color: "#fff",
              fontSize: 12,
            },
            axisLine: {
              lineStyle: {
                color: "#3C6579",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: "#173055",
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#fff",
              fontSize: 12,
            },
          },
        ],
        series: [
          {
            type: "bar",
            barWidth: 30,
            name: "工作时长",
            xAxisIndex: 1, // 使用第一个 xAxis
            yAxisIndex: 0,
            data:[0,0,0,0,0,0],
			 // data: [5, 8, 4, 7, 2, 9],
            itemStyle: {
              borderRadius: [6, 6, 0, 0],
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "#051937" },
                  { offset: 0.1, color: "#0F274C" },
                  { offset: 1, color: "#077EF4" },
                ],
                global: false,
              },
            },
            label: {
              show: false,
              position: "top",
              color: "#fff",
              fontSize: 12,
            },
            markPoint: {
              symbol: "none",
              silent: true,
              data: [
                {
                  name: "top-line",
                  xAxis: "拖拉机",
                  yAxis: 5,
                  symbol: "rect",
                  symbolSize: [30, 4],
                  itemStyle: {
                    color: "#15B0FD",
                  },
                },
                {
                  name: "top-line",
                  xAxis: "收割机",
                  yAxis: 8,
                  symbol: "rect",
                  symbolSize: [30, 4],
                  itemStyle: {
                    color: "#15B0FD",
                  },
                },
                // {
                //   name: "top-line",
                //   xAxis: "无人机",
                //   yAxis: 4,
                //   symbol: "rect",
                //   symbolSize: [30, 4],
                //   itemStyle: {
                //     color: "#15B0FD",
                //   },
                // },
                {
                  name: "top-line",
                  xAxis: "播种机",
                  yAxis: 7,
                  symbol: "rect",
                  symbolSize: [30, 4],
                  itemStyle: {
                    color: "#15B0FD",
                  },
                },
                {
                  name: "top-line",
                  xAxis: "喷药机",
                  yAxis: 2,
                  symbol: "rect",
                  symbolSize: [30, 4],
                  itemStyle: {
                    color: "#15B0FD",
                  },
                },
                {
                  name: "top-line",
                  xAxis: "去雄机",
                  yAxis: 9,
                  symbol: "rect",
                  symbolSize: [30, 4],
                  itemStyle: {
                    color: "#15B0FD",
                  },
                },
              ],
            },
          },
          {
            type: "line",
            showSymbol: true,
            symbolSize: 6,
            name: "工作效率",
            yAxisIndex: 1,
            xAxisIndex: 1, // 使用第二个 xAxis（带偏移的）
            // data: [89, 92, 96, 95, 97, 94],
			data:[0,0,0,0,0,0],
            symbol: "circle",
            lineStyle: {
              color: "#FFD166",
              width: 1,
            },
            itemStyle: {
              color: "#F5CD66",
              borderColor: "rgba(245,205,102,0.4)",
              borderWidth: 12,
              normal: {
                color: "rgba(255, 116, 133, 1)",
                lineStyle: {
                  color: "rgba(255, 116, 133, 1)",
                  width: 2,
                },
              },
            },
            label: {
              show: false,
              position: "top",
              color: "#fff",
              fontSize: 12,
            },
          },
          //   {
          //     name: "",
          //     barGap: "-200%",
          //     type: "bar",
          //     z: 0,
          //     xAxisIndex: 0, // 使用第一个 xAxis
          //     data: [3000, 3000, 3000],
          //     barWidth: 90,
          //     itemStyle: {
          //       normal: {
          //         color: "rgba(4,22,34,0.2)",
          //       },
          //     },
          //   },
        ],
      };

      that.dataLen = option.series[0].data.length;
      that.dispatchActions();

      that.myChart.setOption(option);
      //   this.interVal = setInterval(function () {
      //     that.myChart.clear();
      //     that.myChart.setOption(option);
      //   }, 240000);
      // 20000
    },
    dispatchActions() {
      let that = this;
	  return;
      that.dispatchTimer = setInterval(function () {
        // 取消之前高亮的图形
        that.myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        that.app.currentIndex = (that.app.currentIndex + 1) % that.dataLen;
        //console.log(app.currentIndex);
        // 高亮当前图形
        that.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        // 显示 tooltip
        that.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
      }, 3000);
    },
    clearDispatchTimer() {
      clearInterval(this.dispatchTimer);
    },
    setDispatchTimer() {
      this.dispatchActions();
    },
  },
  destroyed() {
    clearInterval(this.interVal);
  },
};
</script>

<style>
</style>